import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { TextField, MenuItem, createTheme, FormControl, FormControlLabel, Radio, RadioGroup, Button } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { SizesService } from "../../service/sizes.service";
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import React from "react";
import { Brand } from "../../model/brand.model";

function SizeDetails() {
  const params = useParams();  
   
  const navigate = useNavigate();  
  
  const [status, setStatus] = useState(1);
  const [sizeName, setSizeName] = useState("");
  const [isedit, setIsEdit] = useState(true);
  const [availableUnits, setAvailableUnits] = useState<any[]>([]);
  const [selectedUnit, setSelectedUnit] = useState(0);
  const sizesSvc = new SizesService();
  const [errMsg, setErrMsg] = useState('');
  const location = useLocation();
  const [sizeId, setSizeId] = useState("");
  const [selectedBrandId, setSelectedBrandId] = useState("select");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);

  let isLoadDataInit = false;
  let parameters = {}  

  useEffect(() => {

    if (!isLoadDataInit) {
      isLoadDataInit = true;

      console.log("params :: ",location)
      if (location!=null && location.state!=null  && location.state.sizeDetails!=null) {
        parameters = location.state.sizeDetails;

        console.log("params ",parameters)
        
        setSelectedUnit(location.state.sizeDetails.unit);

        setAvailableBrands(location.state.brandsData)
        setSelectedBrandId( location.state.selectedBrand)

        setSizeName(location.state.sizeDetails.size)
        setAvailableUnits(location.state.finishesData)     
        setStatus(location.state.sizeDetails.status)
        setSizeId(location.state.sizeDetails.sizeId)
                        
        setIsEdit(false)
       
        } else if (location!=null && location.state!=null  && location.state.brandsData!=null) {

          setAvailableBrands(location.state.brandsData)
          setSelectedBrandId( location.state.selectedBrand)

        } else {
         // loadProductSizesData();
        } 
    
    }

  }, [])


  useEffect(() => {

    console.log("eeee "+selectedBrandId)

    if (selectedBrandId == "select"){
      return;
    }
    loadProductSizesData();     

 }, [selectedBrandId])

  const loadProductSizesData = () => {

    sizesSvc.productsizes(selectedBrandId).then(data => {
      const res = data.data;
      //const { unit, sizes } = res.data;
      console.log("^^^^^^^^^^^^^^Unit " + res.length);
      // const unitGroups: any = [];
      /*  for (let index = 0; index < res.length; index++) {
          const unitG = res[index].unit;
          const sizesG = res[index].sizes;
          unitGroups.push({ ...sizesG, unit: unitG, });
        }*/
      console.log("grpp ", res);
      setAvailableUnits(res);

    });

  }

  const createNewSize = () => {
    // dispatch(createBrand(brandName,status));

    if (selectedUnit == 0){
      return
    }
    
    const data = {
       "sizeId": sizeId,
       "unit": selectedUnit,
       "size":sizeName,
       "brandId": selectedBrandId,
        "status": status
    };


    sizesSvc.createSize( data).then((res: any) => {
   /*   toast.success('Size created successfully', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('../sizes');
    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong while creating the product');
    }); */
    if (res.status == '100') {

      toast.success("Updated Successfully !!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      setTimeout(() => {
        navigate('../sizes');
      }, 2100);

    } else {
      toast.error("No Data Available!!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      setTimeout(() => {
        navigate('../sizes');
      }, 2100);
    }
  })
};


  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  return (
    <div className="App">
      <div className="card ">

        <div className="card-body">

          <div className="row">

          <div className="col-4 form-group  text-left mt-4">
          <ThemeProvider theme={CustomFontTheme}>
            <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
              className="form-control" name='brandId' defaultValue="select" value={selectedBrandId} 
              disabled={!isedit} 
              onChange={(e: any) => {
                setSelectedBrandId(e.target.value);
              }}>
              <MenuItem style={{fontSize:"small"}} disabled value="select" key="select">Select</MenuItem>
              {availableBrands.map((_el: any) => <MenuItem  style={{fontSize:"small"}}  key={_el.brandId} value={_el.brandId}>{_el.brandName}</MenuItem>)}
            </TextField>
            </ThemeProvider>
          </div>


            <div className="col-4 form-group  text-left mt-4">
              <ThemeProvider theme={CustomFontTheme}>
                <TextField select size="small" label="Size Unit" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  className="form-control" name='selectedUnit' defaultValue="select" value={selectedUnit}
                  disabled={!isedit}
                  onChange={(e: any) => {
                    setSelectedUnit(e.target.value);
                  }}>
                  <MenuItem style={{ fontSize: "small" }} disabled value={0} key={0}>Select</MenuItem>
                  {availableUnits.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.unit} value={_el.unit}>{_el.unit}</MenuItem>)}
                </TextField>
              </ThemeProvider>
            </div>
            <div className="col-md-4 text-left mt-4">
              <ThemeProvider theme={CustomFontTheme}>
                <TextField size="small" label="Size" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  type="text" className="form-control" name='prodDispName' value={sizeName}
               
                  onChange={(e: any) => {
                    setSizeName(e.target.value);
                  }} />
              </ThemeProvider>
            </div>
            <div className="col-md-4 text-left form-group mt-4">
             
                <label className="form-group mr-3 pt-2" > Status</label>
                <FormControl><RadioGroup row name='status' value={status}
                  onChange={(e) => { setStatus(Number(e.target.value)) }} >
                  <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
                </FormControl>
              
            </div>
          </div>
        </div>
        <div className="card-footer col-12 text-center">
          <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewSize()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../sizes')} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default SizeDetails;
